import React from 'react';
function TableCellJsx(prop) {
    const { renderJsx, record, value } = prop || {};
    return React.createElement("div", null, renderJsx?.(record, value));
}
TableCellJsx.displayName = 'TableCellJsx';
export { TableCellJsx };
